import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import SearchInput from '@/shared/Inputs/SearchInput'
import EquipmentTable from 'src/pages/Equipment/components/Tables/EquipmentTable'
import { useState } from 'react'
import CreateEquipmentSidePage from 'src/pages/Equipment/components/SidePages/CreateEquipmentSidePage'
import ProtectedContent from '@/services/rights/ProtectedContent'

const EquipmentTab = () => {
  const [createSidePageOpen, setCreateSidePageOpen] = useState(false)
  const [search, setSearch] = useState('')

  return (
    <>
      <div className="inline-flex-gap gap8">
        <ProtectedContent requiredRight="equipment:create">
          <CreateEntityButton onClick={() => setCreateSidePageOpen(true)} text="Добавить лифт" />
        </ProtectedContent>
        <SearchInput value={search} name="search" onChange={setSearch} placeHolder="Поиск по лифтам и адресам" />
      </div>
      <EquipmentTable search={search} />
      <CreateEquipmentSidePage open={createSidePageOpen} onClose={() => setCreateSidePageOpen(false)} />
    </>
  )
}

export default EquipmentTab
